import React from 'react';
import { DatePicker as AntDataPicker } from 'antd';
import locale from 'antd/lib/date-picker/locale/fr_FR';
import dayjs from 'dayjs';
import styled from 'styled-components';
interface DatePickerProps {
  id: string;
  placeholder: string;
  picker?: 'time' | 'date' | 'week' | 'month' | 'quarter' | 'year' | undefined;
  name: string;
  onChange: (value: any) => void;
  defaultValue: dayjs.Dayjs;
  disabledDate?: (value: any) => boolean;
  isDisabled?: boolean;
}

const defaultPickerValue: any = dayjs().year(1989);

export const DatePicker: React.FC<DatePickerProps> = ({
  placeholder,
  name,
  picker,
  onChange,
  defaultValue,
  disabledDate,
  isDisabled,
}) => {
  const getPicker = () => {
    switch (picker) {
      case 'year':
        return (
          <AntDataPicker
            style={{ width: '100%', cursor: 'pointer' }}
            id={name}
            placeholder={placeholder}
            picker={picker}
            getPopupContainer={(trigger: any) => trigger.parentElement}
            locale={locale}
            size="large"
            defaultPickerValue={defaultPickerValue}
            onChange={onChange}
            defaultValue={defaultValue}
            disabled={isDisabled}
          />
        );
      case 'date':
        return (
          <AntDataPicker
            id={name}
            placeholder={placeholder}
            format="DD/MM/YYYY"
            locale={locale}
            getPopupContainer={(trigger: any) => trigger.parentElement}
            onChange={onChange}
            disabledDate={disabledDate}
            defaultValue={defaultValue}
            disabled={isDisabled}
          />
        );
      default:
        return (
          <AntDataPicker
            id={name}
            showTime
            placeholder={placeholder}
            format="DD/MM/YYYY HH:mm"
            locale={locale}
            getPopupContainer={(trigger: any) => trigger.parentElement}
            disabledDate={disabledDate}
            onChange={onChange}
            defaultValue={defaultValue}
            disabled={isDisabled}
          />
        );
    }
  };

  return <PickerContainer>{getPicker()}</PickerContainer>;
};

const PickerContainer = styled.div`
  .ant-picker {
    width: 100%;
    cursor: pointer;
    height: 40px;
  }
  .ant-picker-header {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-picker-header-view {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-picker-header > button {
    display: flex;
    justify-content: center;
  }
`;
